<template>
  <img :src="src || fallback" alt="" class="rounded-full object-cover inline-block flex-shrink-0" :class="size" />
</template>

<script setup>
import fallback from '../../assets/logos/refrag-avatar.svg';

defineProps({
  src: { type: String, default: null },
  size: { type: String, default: 'w-8 h-8' },
});
</script>
